<template>
  <router-view />
</template>

<script>
export default {
  name: "SampleSingle"
};
</script>
